import {
    validateEmail,
    validateFirstName,
    validateLastName,
    validatePhone,
    validateInternationalPostalCode,
    validateCountry,
    validateTOS
} from '../Shared/validations';

export const validatePopup = values => {
    const errors = {
        ...validateInternationalPostalCode(values),
        ...validateCountry(values)
    };
    return errors;
};
export const validate = values => {
    const errors = {
        ...validateEmail(values),
        ...validateFirstName(values),
        ...validateLastName(values),
        ...validatePhone(values),
        ...validateInternationalPostalCode(values),
        ...validateCountry(values),
        ...validateTOS(values)
    };
    return errors;
};
